module.exports = __webpack_public_path__ + "static/media/buddyReferralCloseIcon.b44ae071.svg";